// File: 3d-main.js – Main entry: scene setup, UI toggle, module initialization, clean-export
// Апрель 2025. Добавлены модули Models, Decals и Groups.

import * as SCN   from './3d-scene.js';
import * as UI    from './3d-ui.js';
import { autoSave } from './3d-ui-storage.js';
import * as WAL   from './3d-wall.js';
import * as LGT   from './3d-lighting.js';
import * as MED   from './3d-media.js';
import * as ANIM  from './3d-animations.js';
import * as MODL  from './3d-models.js';
import * as DCL   from './3d-decals.js';
import * as GRP   from './3d-groups.js';

window.SCN = SCN;

/* 0) Инициализация сцены в видимом контейнере */
(() => {
  const containers = Array.from(document.querySelectorAll('.threejs-container'));
  const visible = containers.find(el => getComputedStyle(el).display !== 'none') || containers[0];
  const initArg = typeof visible === 'string' || visible.id ? `#${visible.id}` : visible;
  console.info('[3D] init target →', initArg);
  SCN.init(initArg);
})();

/* 1) DPR patch + aspect-ratio reset */
function applyDPR() {
  const portrait = matchMedia('(orientation: portrait)').matches;
  const limit    = portrait ? 1.5 : 2.0;
  const dpr      = Math.min(window.devicePixelRatio || 1, limit);
  if (SCN.renderer.getPixelRatio() !== dpr) {
    const cvs  = SCN.renderer.domElement;
    const rect = cvs.getBoundingClientRect();
    SCN.renderer.setPixelRatio(dpr);
    SCN.renderer.setSize(rect.width, rect.height, false);
    SCN.camera.updateProjectionMatrix();
    cvs.style.aspectRatio = 'auto';
    console.info('[3D] DPR', dpr, '| aspect-ratio reset');
  }
}
applyDPR();
window.addEventListener('resize', applyDPR);
matchMedia('(orientation: portrait)').addEventListener('change', applyDPR);

/* 2) UI mode vs clean-export */
const toggleBtn = document.getElementById('toggleSettingsButton');
const panel     = document.getElementById('controlPanel');

if (toggleBtn && panel) {
  // Interactive UI
  toggleBtn.addEventListener('click', () => {
    const hide = panel.style.display === 'none';
    panel.style.display   = hide ? '' : 'none';
    toggleBtn.textContent = hide ? 'Hide Settings' : 'Show Settings';
  });

  // build and wire up UI
  UI.init();
  SCN.initCameraControls();
  UI.REG.screenshot.onclick = () => SCN.takeScreenshot(+UI.REG.screenshotScale.value || 1);

  // initial module inits
  ANIM.init();
  WAL.init();
  LGT.init();
  MED.init();
  MODL.init();
  DCL.init();
  GRP.init();

  // when user loads a JSON file…
  UI.REG.load.addEventListener('change', e => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => {
      const cfg = JSON.parse(ev.target.result);

      // clear out existing dynamic entries
      UI.clearDynamicLists();
      UI.clearDynamicRegistry();

      // apply loaded settings into UI controls
      UI.apply(cfg);

      // immediately persist to localStorage so it survives reload
      autoSave();

      // re-initialize all dynamic modules
      ANIM.init();
      UI.initDynamicModules();
    };
    reader.readAsText(file);
  });

} else {
  // Clean-export (no UI)
  const cfg = window.EXPORT_SETTINGS || {};
  ['lights','animations','medias','models','decals','walls','groups'].forEach(k => {
    if (!Array.isArray(cfg[k])) cfg[k] = [];
  });
  Object.assign(cfg, {
    mainColor: cfg.mainColor ?? '#ffffff',
    mainI:     cfg.mainI     ?? 1,
    mainX:     cfg.mainX     ?? 0,
    mainY:     cfg.mainY     ?? 5,
    mainZ:     cfg.mainZ     ?? 5,
    mainAnim:  cfg.mainAnim  ?? 'none'
  });

  try {
    ANIM.initClean(cfg.animations);
    WAL.initClean(cfg);
    LGT.initClean(cfg);
    MED.initClean(cfg.medias);
    MODL.initClean(cfg.models);
    // decals clean not supported yet
    GRP.initClean(cfg);
  } catch (err) {
    console.error('[3D] clean-export bootstrap error', err);
  }
}

/* 3) Запуск цикла рендеринга */
SCN.animate();
